import { dtsAPI } from "../../axios";

export const actions = {
    GetClientSteps(context, data){
        return dtsAPI.get(`ProcessTypeClientStep/All/${data}`);
    },
    CreateClientStep(context, data){
        return dtsAPI.post(`ProcessTypeClientStep/Add`, data);
    },
    UpdateClientStep(context, data){
        return dtsAPI.put(`ProcessTypeClientStep/${data.id}`, data);
    },
    RemoveClientStep(context, data){
        return dtsAPI.delete(`ProcessTypeClientStep/${data}`);
    },
}